// this is an autogenerated file from App/Account/Content/Settings/Content/CommsSettings/Settings/mutation-update.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsSettings_Settings(
  $id: uuid!
  $sending_window: jsonb!
  $flags: jsonb!
) {
  update_comms_settings_by_pk(
    pk_columns: { id: $id }
    _set: { sending_window: $sending_window, flags: $flags }
  ) {
    id
  }
}

`